export default {
  SET_FAQS (state, faqs) {
    state.faqs = faqs
  },
  REMOVE_RECORD (state, itemId) {
    const roleIndex = state.faqs.findIndex((u) => u.id === itemId)
    state.faqs.splice(roleIndex, 1)
  }
}
